/* unplugin-vue-components disabled */import script from "./TagPanel.vue?vue&type=script&setup=true&lang=ts"
export * from "./TagPanel.vue?vue&type=script&setup=true&lang=ts"

import "./TagPanel.vue?vue&type=style&index=0&id=76095263&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-76095263"]])

export default __exports__